import React from 'react';
import styled from '@emotion/styled';
import { Button } from 'rsuite';
import { OrderListItem } from '../../api/apiTypes';
import OrdersTableErrorPopover from './OrdersTableErrorPopover';
import { deleteLabelsError, deleteMarketplaceResponseError } from '../../api/orders';
import { showSuccessMessage } from '../../utils/message';
import { useStoreState } from '../../store/hooks';
import { Permission } from '../../store/user/types';

interface Props {
  order: OrderListItem;
  onOrderChange?: (order: OrderListItem) => void;
}

const Container = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    padding-top: 2px;
`;

const RemoveButton = styled(Button)`
    padding: 0;
`;

export default function OrdersTableError({
  order,
  onOrderChange,
}: Props) {
  const { hasPermission } = useStoreState(state => state.user);
  const isResponseErrorVisible = !!order.updateStatusResponseError;
  const isLabelsErrorVisible = !!order.labelsError;
  const isRemoveButtonVisible = hasPermission(Permission.RemoveOrderError);

  function updateOrderStatusResponseError() {
    order.updateStatusResponseError = null;
    onOrderChange?.(order);
  }

  function updateOrderLabelsError() {
    order.labelsError = undefined;
    onOrderChange?.(order);
  }

  async function sendDeleteMarketplaceResponseErrorRequest() {
    const orderId = order.id;

    await deleteMarketplaceResponseError(orderId);

    updateOrderStatusResponseError();

    showSuccessMessage('Status response error successfully removed.');
  }

  async function sendDeleteLabelsErrorRequest() {
    const orderId = order.id;

    await deleteLabelsError(orderId);

    updateOrderLabelsError();

    showSuccessMessage('Labels error successfully removed.');
  }

  function handleDeleteResponseError() {
    sendDeleteMarketplaceResponseErrorRequest();
  }

  function handleDeleteLabelsError() {
    sendDeleteLabelsErrorRequest();
  }

  return (
    <Container>
      {
        isResponseErrorVisible && (
          <OrdersTableErrorPopover
            message={order.updateStatusResponseError ?? ''}
            color="red"
          >
            {
              isRemoveButtonVisible && (
                <RemoveButton
                  appearance="link"
                  size="xs"
                  onClick={() => handleDeleteResponseError()}
                >
                  Remove message
                </RemoveButton>
              )
            }
          </OrdersTableErrorPopover>
        )
      }
      {
        isLabelsErrorVisible && (
          <OrdersTableErrorPopover
            message={order.labelsError ?? ''}
            color="orange"
          >
            {
              isRemoveButtonVisible && (
              <RemoveButton
                appearance="link"
                size="xs"
                onClick={() => handleDeleteLabelsError()}
              >
                Remove message
              </RemoveButton>
              )
            }
          </OrdersTableErrorPopover>
        )
      }
    </Container>
  );
}

OrdersTableError.defaultProps = {
  onOrderChange: undefined,
};
